import { useCallback, useState } from "react";

const useOfferPriceLoading = (setPageLoading) => {
  const [refetchLoading, setRefetchLoading] = useState(false);

  const startPriceLoading = useCallback(() => {
    setRefetchLoading(true);
  }, []);

  const stopPriceLoading = useCallback(() => {
    setRefetchLoading(false);
    setPageLoading(false);
  }, [setPageLoading]);

  return { refetchLoading, startPriceLoading, stopPriceLoading };
};

export default useOfferPriceLoading;
